import { render, staticRenderFns } from "./SatisfacaoRating.vue?vue&type=template&id=f0f57cde&"
import script from "./SatisfacaoRating.vue?vue&type=script&lang=js&"
export * from "./SatisfacaoRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports